// v1 without cash


// import React from "react";
// import {
//   Box,
//   Typography,
//   TextField,
//   Button,
//   Container,
//   Paper,
//   Stack,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Select,
// } from "@mui/material";
// import TwoFieldRow from "./twoFieldsRow";
// import UploadWithLabel from "./uploadWithLable";
// import { Formik, Form, FieldArray } from "formik";
// import * as Yup from "yup";
// import { useTranslation } from "react-i18next";

// const createValidationSchema = (t) =>
//   Yup.object({
//     depositedBanks: Yup.array()
//       .of(
//         Yup.object({
//           acc_no: Yup.string().required(t("depositedBanks.validation.accNoRequired")),
//           bank_name: Yup.string().required(t("depositedBanks.validation.bankNameRequired")),
//           branch_name: Yup.string().required(t("depositedBanks.validation.branchNameRequired")),
//           ifsc_code: Yup.string().required(t("depositedBanks.validation.ifscCodeRequired")),
//           deposted_amt: Yup.number()
//             .typeError(t("depositedBanks.validation.depositedAmtNumber"))
//             .required(t("depositedBanks.validation.depositedAmtRequired")),
//           date_of_deposit: Yup.date()
//             .required(t("depositedBanks.validation.dateRequired"))
//             .nullable(),
//           mode_of_payment: Yup.string().required(t("depositedBanks.validation.modeRequired")),
//           type_of_scheme: Yup.string().required(t("depositedBanks.validation.schemeRequired")),
//           remark: Yup.string().nullable(),
//           statement_doc: Yup.mixed()
//             .required(t("depositedBanks.validation.statementRequired"))
//             .test(
//               "fileSize",
//               t("baseInfo.validation.fileSizeExceeded"),
//               (value) => !value || value.size <= 2 * 1024 * 1024
//             ),
//         })
//       )
//       .min(1, t("depositedBanks.validation.atLeastOne")),
//   });

// const DepositedBanksSection = ({
//   depositedBanks,
//   setDepositedBanks,
//   activeTab,
//   setActiveTab,
//   totalInvestment,
//   schemeOptions,
//   investments,
// }) => {
//   const { t, i18n } = useTranslation();

//   const validationSchema = React.useMemo(() => createValidationSchema(t), [i18n.language]);

//   // Autofill bank details on acc_no change
//   const handleAccountChange = (formikHelpers, index, acc_no) => {
//     const selectedInvestment = investments.find((inv) => inv.inv_account_no === acc_no);
//     if (selectedInvestment) {
//       formikHelpers.setFieldValue(`depositedBanks[${index}].acc_no`, selectedInvestment.inv_account_no);
//       formikHelpers.setFieldValue(`depositedBanks[${index}].bank_name`, selectedInvestment.inv_bank_name);
//       formikHelpers.setFieldValue(`depositedBanks[${index}].ifsc_code`, selectedInvestment.inv_ifsc_code);
//       formikHelpers.setFieldValue(`depositedBanks[${index}].branch_name`, selectedInvestment.inv_branch_name);
//       formikHelpers.setFieldValue(`depositedBanks[${index}].type_of_scheme`, selectedInvestment.inv_scheme);
//     } else {
//       formikHelpers.setFieldValue(`depositedBanks[${index}].bank_name`, "");
//       formikHelpers.setFieldValue(`depositedBanks[${index}].ifsc_code`, "");
//       formikHelpers.setFieldValue(`depositedBanks[${index}].branch_name`, "");
//       formikHelpers.setFieldValue(`depositedBanks[${index}].type_of_scheme`, "");
//       formikHelpers.setFieldValue(`depositedBanks[${index}].acc_no`, "");
//     }
//   };

//   return (
//     <Formik
//       initialValues={{ depositedBanks }}
//       validationSchema={validationSchema}
//       enableReinitialize
//       validate={(values) => {
//         const errors = {};
//         const sumDeposited = values.depositedBanks.reduce(
//           (sum, d) => sum + (Number(d.deposted_amt) || 0),
//           0
//         );
//         if (
//           totalInvestment !== undefined &&
//           Number(sumDeposited.toFixed(2)) !== Number(totalInvestment.toFixed(2))
//         ) {
//           errors._totalMismatch = t("depositedBanks.totalMismatchMessage", {
//             sumDeposited: sumDeposited.toFixed(2),
//             totalInvestment: Number(totalInvestment).toFixed(2),
//           });
//         }
//         return errors;
//       }}
//       onSubmit={(values) => {
//         setDepositedBanks(values.depositedBanks);
//         setActiveTab(activeTab + 1);
//       }}
//     >
//       {(formik) => (
//         <Form noValidate>
//           <Container maxWidth={false} sx={{ mt: 5, maxWidth: 800 }}>
//             <Paper elevation={4} sx={{ p: 4, borderRadius: 3 }}>
//               <Typography variant="h4" fontWeight="700" color="primary.main" gutterBottom>
//                 {t("depositedBanks.heading")}
//               </Typography>
//               <FieldArray name="depositedBanks">
//                 {(arrayHelpers) => (
//                   <>
//                     {formik.values.depositedBanks.map((dep, index) => {
//                       const touched = formik.touched.depositedBanks?.[index] || {};
//                       const errors = formik.errors.depositedBanks?.[index] || {};
//                       return (
//                         <Box
//                           key={index}
//                           mb={2}
//                           p={2}
//                           sx={{ border: "1px solid #ccc", borderRadius: 2 }}
//                         >
//                           <TwoFieldRow>
//                             <FormControl fullWidth>
//                               <InputLabel id={`acc_no_label_${index}`}>
//                                 {t("depositedBanks.accNo")}
//                               </InputLabel>
//                               <Select
//                                 labelId={`acc_no_label_${index}`}
//                                 name={`depositedBanks[${index}].acc_no`}
//                                 value={dep.acc_no || ""}
//                                 label={t("depositedBanks.accNo")}
//                                 onChange={(e) => handleAccountChange(formik, index, e.target.value)}
//                                 onBlur={formik.handleBlur}
//                                 error={Boolean(touched.acc_no && errors.acc_no)}
//                               >
//                                 <MenuItem value="">
//                                   <em>{t("common.select")}</em>
//                                 </MenuItem>
//                                 {investments.map((inv) => (
//                                   <MenuItem key={inv.inv_account_no} value={inv.inv_account_no}>
//                                     {`${inv.inv_account_no} - ${inv.inv_scheme}`}
//                                   </MenuItem>
//                                 ))}
//                               </Select>
//                               {touched.acc_no && errors.acc_no && (
//                                 <Typography color="error" variant="caption" sx={{ ml: 2 }}>
//                                   {errors.acc_no}
//                                 </Typography>
//                               )}
//                             </FormControl>

//                             <TextField
//                               label={t("depositedBanks.bankName")}
//                               name={`depositedBanks[${index}].bank_name`}
//                               value={dep.bank_name}
//                               InputProps={{ readOnly: true }}
//                               fullWidth
//                               sx={{ ml: 2 }}
//                             />
//                           </TwoFieldRow>

//                           <TwoFieldRow>
//                             <TextField
//                               label={t("depositedBanks.ifscCode")}
//                               name={`depositedBanks[${index}].ifsc_code`}
//                               value={dep.ifsc_code}
//                               InputProps={{ readOnly: true }}
//                               fullWidth
//                               error={Boolean(touched.ifsc_code && errors.ifsc_code)}
//                               helperText={touched.ifsc_code && errors.ifsc_code}
//                             />
//                             <TextField
//                               label={t("depositedBanks.branchName")}
//                               name={`depositedBanks[${index}].branch_name`}
//                               value={dep.branch_name}
//                               InputProps={{ readOnly: true }}
//                               fullWidth
//                               error={Boolean(touched.branch_name && errors.branch_name)}
//                               helperText={touched.branch_name && errors.branch_name}
//                             />
//                           </TwoFieldRow>

//                           {/* Scheme as read-only TextField */}
//                           <TextField
//                             label={t("depositedBanks.typeOfScheme")}
//                             name={`depositedBanks[${index}].type_of_scheme`}
//                             value={dep.type_of_scheme || ""}
//                             InputProps={{ readOnly: true }}
//                             fullWidth
//                             error={Boolean(touched.type_of_scheme && errors.type_of_scheme)}
//                             helperText={touched.type_of_scheme && errors.type_of_scheme}
//                             sx={{ mb: 2 }}
//                           />

//                           <TwoFieldRow>
//                             <TextField
//                               label={t("depositedBanks.depositedAmount")}
//                               name={`depositedBanks[${index}].deposted_amt`}
//                               value={dep.deposted_amt}
//                               onChange={formik.handleChange}
//                               onBlur={formik.handleBlur}
//                               fullWidth
//                               error={Boolean(touched.deposted_amt && errors.deposted_amt)}
//                               helperText={touched.deposted_amt && errors.deposted_amt}
//                             />
//                             <TextField
//                               label={t("depositedBanks.dateOfDeposit")}
//                               name={`depositedBanks[${index}].date_of_deposit`}
//                               type="date"
//                               InputLabelProps={{ shrink: true }}
//                               value={dep.date_of_deposit || ""}
//                               onChange={formik.handleChange}
//                               onBlur={formik.handleBlur}
//                               fullWidth
//                               error={Boolean(touched.date_of_deposit && errors.date_of_deposit)}
//                               helperText={touched.date_of_deposit && errors.date_of_deposit}
//                             />
//                           </TwoFieldRow>

//                           <TwoFieldRow>
//                             <TextField
//                               select
//                               label={t("depositedBanks.modeOfDeposit")}
//                               name={`depositedBanks[${index}].mode_of_payment`}
//                               value={dep.mode_of_payment || ""}
//                               onChange={formik.handleChange}
//                               onBlur={formik.handleBlur}
//                               fullWidth
//                               error={Boolean(touched.mode_of_payment && errors.mode_of_payment)}
//                               helperText={touched.mode_of_payment && errors.mode_of_payment}
//                             >
//                               <MenuItem value="">{t("depositedBanks.selectMode")}</MenuItem>
//                               <MenuItem value="NEFT">NEFT</MenuItem>
//                               <MenuItem value="Cash">Cash</MenuItem>
//                               <MenuItem value="Cheque">Cheque</MenuItem>
//                               <MenuItem value="RTGS">RTGS</MenuItem>
//                               <MenuItem value="UPI">UPI</MenuItem>
//                             </TextField>

//                             <TextField
//                               label={t("depositedBanks.remark")}
//                               name={`depositedBanks[${index}].remark`}
//                               value={dep.remark || ""}
//                               onChange={formik.handleChange}
//                               onBlur={formik.handleBlur}
//                               fullWidth
//                               multiline
//                               error={Boolean(touched.remark && errors.remark)}
//                               helperText={touched.remark && errors.remark}
//                             />
//                           </TwoFieldRow>

//                           <Box sx={{ display: "flex", flexDirection: "column", mb: 1 }}>
//                             <UploadWithLabel
//                               label={t("depositedBanks.uploadStatement")}
//                               name={`depositedBanks[${index}].statement_doc`}
//                               onChange={(e) => {
//                                 formik.setFieldValue(
//                                   `depositedBanks[${index}].statement_doc`,
//                                   e.currentTarget.files[0]
//                                 );
//                                 formik.setFieldTouched(`depositedBanks[${index}].statement_doc`, true);
//                               }}
//                               file={dep.statement_doc}
//                             />
//                             {touched.statement_doc && errors.statement_doc && (
//                               <Typography color="error" variant="caption" sx={{ mt: 0.5 }}>
//                                 {errors.statement_doc}
//                               </Typography>
//                             )}
//                           </Box>

//                           <Button
//                             variant="outlined"
//                             color="error"
//                             disabled={formik.values.depositedBanks.length === 1}
//                             onClick={() => arrayHelpers.remove(index)}
//                             sx={{ mt: 1 }}
//                           >
//                             {t("common.remove")}
//                           </Button>
//                         </Box>
//                       );
//                     })}
//                     <Button
//                       variant="contained"
//                       sx={{ mt: 2 }}
//                       onClick={() =>
//                         arrayHelpers.push({
//                           acc_no: "",
//                           bank_name: "",
//                           ifsc_code: "",
//                           branch_name: "",
//                           date_of_deposit: "",
//                           deposted_amt: "",
//                           particulars: "",
//                           remark: "",
//                           client_id: "",
//                           mode_of_payment: "",
//                           type_of_scheme: "",
//                           statement_doc: null,
//                         })
//                       }
//                     >
//                       {t("depositedBanks.addDepositedBank")}
//                     </Button>
//                   </>
//                 )}
//               </FieldArray>

//               <Box
//                 sx={{
//                   mt: 4,
//                   p: 2,
//                   border: "1px solid #999",
//                   borderRadius: 2,
//                   backgroundColor: "#f9f9f9",
//                 }}
//               >
//                 <Typography variant="h6" gutterBottom>
//                   {t("depositedBanks.totalDepositedAmountReadOnly")}
//                 </Typography>
//                 <TextField
//                   label={t("depositedBanks.totalDepositedAmount")}
//                   value={formik.values.depositedBanks
//                     .reduce((sum, d) => sum + (Number(d.deposted_amt) || 0), 0)
//                     .toFixed(2)}
//                   InputProps={{ readOnly: true }}
//                   fullWidth
//                   error={Boolean(formik.errors._totalMismatch)}
//                   helperText={formik.errors._totalMismatch}
//                 />
//               </Box>

//               <Box mt={1} sx={{ display: "flex", justifyContent: "space-between" }}>
//                 <Button
//                   variant="outlined"
//                   onClick={() => activeTab > 0 && setActiveTab(activeTab - 1)}
//                 >
//                   {t("common.back")}
//                 </Button>
//                 <Button type="submit" variant="contained">
//                   {t("common.next")}
//                 </Button>
//               </Box>
//             </Paper>
//           </Container>
//         </Form>
//       )}
//     </Formik>
//   );
// };

// export default DepositedBanksSection;


// v2 with cash
// import React from "react";
// import {
//   Box,
//   Typography,
//   TextField,
//   Button,
//   Container,
//   Paper,
//   Stack,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Select,
// } from "@mui/material";
// import TwoFieldRow from "./twoFieldsRow";
// import UploadWithLabel from "./uploadWithLable";
// import { Formik, Form, FieldArray } from "formik";
// import * as Yup from "yup";
// import { useTranslation } from "react-i18next";

// const DepositedBanksSection = ({
//   depositedBanks,
//   setDepositedBanks,
//   activeTab,
//   setActiveTab,
//   totalInvestment,
//   schemeOptions,
//   investments,
// }) => {
//   const { t, i18n } = useTranslation();
//   console.log("Investments in DepositedBanksSection:", investments);

//   // Function to check if a date is in the future
//   const isFutureDate = (dateString) => {
//     if (!dateString) return false;
//     const inputDate = new Date(dateString);
//     const today = new Date();
//     // Reset times to compare only dates
//     today.setHours(0, 0, 0, 0);
//     inputDate.setHours(0, 0, 0, 0);
//     return inputDate > today;
//   };

//   // Create validation schema with conditional validation for acc_no
//   const createValidationSchema = (t) =>
//     Yup.object({
//       depositedBanks: Yup.array()
//         .of(
//           Yup.object({
//             acc_no: Yup.string()
//               .test(
//                 "acc-no-required",
//                 t("depositedBanks.validation.accNoRequired"),
//                 function (value) {
//                   // Get the current bank data to check if it's CASH
//                   const { bank_name } = this.parent;
//                   // If bank_name is "CASH", then acc_no is not required
//                   if (bank_name === "CASH") {
//                     return true; // Validation passes for CASH
//                   }
//                   // Otherwise, acc_no is required
//                   return !!value && value.trim() !== "";
//                 }
//               ),
//             bank_name: Yup.string().required(t("depositedBanks.validation.bankNameRequired")),
//             branch_name: Yup.string().required(t("depositedBanks.validation.branchNameRequired")),
//             ifsc_code: Yup.string().required(t("depositedBanks.validation.ifscCodeRequired")),
//             deposted_amt: Yup.number()
//               .typeError(t("depositedBanks.validation.depositedAmtNumber"))
//               .required(t("depositedBanks.validation.depositedAmtRequired")),
//             date_of_deposit: Yup.date()
//               .required(t("depositedBanks.validation.dateRequired"))
//               .nullable()
//               .test(
//                 "not-future-date",
//                 t("depositedBanks.validation.dateNotFuture"),
//                 (value) => {
//                   if (!value) return true; // Let required validation handle empty dates
//                   return !isFutureDate(value);
//                 }
//               ),
//             mode_of_payment: Yup.string().required(t("depositedBanks.validation.modeRequired")),
//             type_of_scheme: Yup.string().required(t("depositedBanks.validation.schemeRequired")),
//             remark: Yup.string().nullable(),
//             statement_doc: Yup.mixed()
//               .required(t("depositedBanks.validation.statementRequired"))
//               .test(
//                 "fileType",
//                 t("depositedBanks.validation.fileMustBePDF"),
//                 (value) => !value || (value && value.type === "application/pdf")
//               )
//               .test(
//                 "fileSize",
//                 t("baseInfo.validation.fileSizeExceeded"),
//                 (value) => !value || value.size <= 2 * 1024 * 1024
//               ),
//           })
//         )
//         .min(1, t("depositedBanks.validation.atLeastOne")),
//     });

//   const validationSchema = React.useMemo(() => createValidationSchema(t), [i18n.language]);

//   // Updated: Autofill bank details on acc_no change
//   const handleAccountChange = (formikHelpers, index, acc_no) => {
//     // Check if this is a CASH option (starts with "CASH_")
//     if (acc_no && acc_no.startsWith("CASH_")) {
//       // Extract scheme from CASH option (format: "CASH_FD")
//       const scheme = acc_no.replace("CASH_", "");
//       // Set empty account number for CASH transactions
//       formikHelpers.setFieldValue(`depositedBanks[${index}].acc_no`, "");
//       formikHelpers.setFieldValue(`depositedBanks[${index}].bank_name`, "CASH");
//       formikHelpers.setFieldValue(`depositedBanks[${index}].ifsc_code`, "CASH");
//       formikHelpers.setFieldValue(`depositedBanks[${index}].branch_name`, "CASH");
//       formikHelpers.setFieldValue(`depositedBanks[${index}].type_of_scheme`, scheme);
//       return;
//     }

//     // Regular investment account
//     const selectedInvestment = investments.find((inv) => inv.inv_account_no === acc_no);
    
//     if (selectedInvestment) {
//       formikHelpers.setFieldValue(`depositedBanks[${index}].acc_no`, selectedInvestment.inv_account_no || "");
//       formikHelpers.setFieldValue(`depositedBanks[${index}].bank_name`, selectedInvestment.inv_bank_name || "");
//       formikHelpers.setFieldValue(`depositedBanks[${index}].ifsc_code`, selectedInvestment.inv_ifsc_code || "");
//       formikHelpers.setFieldValue(`depositedBanks[${index}].branch_name`, selectedInvestment.inv_branch_name || "");
//       formikHelpers.setFieldValue(`depositedBanks[${index}].type_of_scheme`, selectedInvestment.inv_scheme || "");
//     } else {
//       // Clear fields if no matching investment found
//       formikHelpers.setFieldValue(`depositedBanks[${index}].bank_name`, "");
//       formikHelpers.setFieldValue(`depositedBanks[${index}].ifsc_code`, "");
//       formikHelpers.setFieldValue(`depositedBanks[${index}].branch_name`, "");
//       formikHelpers.setFieldValue(`depositedBanks[${index}].type_of_scheme`, "");
//       formikHelpers.setFieldValue(`depositedBanks[${index}].acc_no`, acc_no || "");
//     }
//   };

//   // Prepare investment options for the dropdown
//   const getInvestmentOptions = () => {
//     const options = [];
//     const schemeWithAccount = new Set(); // Track schemes that have account numbers
    
//     // First, add all investment accounts with their schemes
//     investments.forEach((inv) => {
//       if (inv.inv_account_no && inv.inv_scheme) {
//         const scheme = inv.inv_scheme;
//         const displayLabel = `${inv.inv_account_no} - ${scheme}`;
//         options.push({
//           value: inv.inv_account_no,
//           label: displayLabel,
//           scheme: scheme,
//           hasAccount: true
//         });
//         // Mark this scheme as having an account
//         schemeWithAccount.add(scheme);
//       }
//     });
    
//     // Add CASH options only for schemes that don't already have an account
//     schemeOptions.forEach((scheme) => {
//       if (scheme && !schemeWithAccount.has(scheme)) {
//         options.push({
//           value: `CASH_${scheme}`,
//           label: `- ${scheme}`,
//           scheme: scheme,
//           hasAccount: false
//         });
//       }
//     });
    
//     return options;
//   };

//   const investmentOptions = getInvestmentOptions();

//   return (
//     <Formik
//       initialValues={{ depositedBanks }}
//       validationSchema={validationSchema}
//       enableReinitialize
//       validate={(values) => {
//         const errors = {};
//         const sumDeposited = values.depositedBanks.reduce(
//           (sum, d) => sum + (Number(d.deposted_amt) || 0),
//           0
//         );
//         if (
//           totalInvestment !== undefined &&
//           Number(sumDeposited.toFixed(2)) !== Number(totalInvestment.toFixed(2))
//         ) {
//           errors._totalMismatch = t("depositedBanks.totalMismatchMessage", {
//             sumDeposited: sumDeposited.toFixed(2),
//             totalInvestment: Number(totalInvestment).toFixed(2),
//           });
//         }
//         return errors;
//       }}
//       onSubmit={(values) => {
//         setDepositedBanks(values.depositedBanks);
//         setActiveTab(activeTab + 1);
//       }}
//     >
//       {(formik) => (
//         <Form noValidate>
//           <Container maxWidth={false} sx={{ mt: 5, maxWidth: 800 }}>
//             <Paper elevation={4} sx={{ p: 4, borderRadius: 3 }}>
//               <Typography variant="h4" fontWeight="700" color="primary.main" gutterBottom>
//                 {t("depositedBanks.heading")}
//               </Typography>
//               <FieldArray name="depositedBanks">
//                 {(arrayHelpers) => (
//                   <>
//                     {formik.values.depositedBanks.map((dep, index) => {
//                       const touched = formik.touched.depositedBanks?.[index] || {};
//                       const errors = formik.errors.depositedBanks?.[index] || {};
                      
//                       // Check if current selection is CASH
//                       const isCash = dep.bank_name === "CASH" || 
//                                      dep.ifsc_code === "CASH" || 
//                                      dep.branch_name === "CASH";
                      
//                       // Get today's date in YYYY-MM-DD format for max date
//                       const today = new Date().toISOString().split('T')[0];
                      
//                       return (
//                         <Box
//                           key={index}
//                           mb={2}
//                           p={2}
//                           sx={{ border: "1px solid #ccc", borderRadius: 2 }}
//                         >
//                           <TwoFieldRow>
//                             <FormControl fullWidth sx={{ minWidth: 250 }}>
//                               <InputLabel id={`acc_no_label_${index}`}>
//                                 {t("depositedBanks.accNo")}
//                               </InputLabel>
//                               <Select
//                                 labelId={`acc_no_label_${index}`}
//                                 name={`depositedBanks[${index}].acc_no`}
//                                 value={dep.acc_no || ""}
//                                 label={t("depositedBanks.accNo")}
//                                 onChange={(e) => {
//                                   const value = e.target.value;
//                                   formik.handleChange(e);
//                                   handleAccountChange(formik, index, value);
//                                 }}
//                                 onBlur={formik.handleBlur}
//                                 error={Boolean(touched.acc_no && errors.acc_no)}
//                               >
//                                 <MenuItem value="">
//                                   <em>{t("common.select")}</em>
//                                 </MenuItem>
//                                 {investmentOptions.map((option) => (
//                                   <MenuItem key={option.value} value={option.value}>
//                                     {option.label}
//                                   </MenuItem>
//                                 ))}
//                               </Select>
//                               {touched.acc_no && errors.acc_no && (
//                                 <Typography color="error" variant="caption" sx={{ ml: 2 }}>
//                                   {errors.acc_no}
//                                 </Typography>
//                               )}
//                             </FormControl>

//                             <TextField
//                               label={t("depositedBanks.bankName")}
//                               name={`depositedBanks[${index}].bank_name`}
//                               value={dep.bank_name}
//                               InputProps={{ readOnly: true }}
//                               fullWidth
//                               sx={{ ml: 2, minWidth: 250 }}
//                             />
//                           </TwoFieldRow>

//                           <TwoFieldRow>
//                             <TextField
//                               label={t("depositedBanks.ifscCode")}
//                               name={`depositedBanks[${index}].ifsc_code`}
//                               value={dep.ifsc_code}
//                               InputProps={{ readOnly: true }}
//                               fullWidth
//                               error={Boolean(touched.ifsc_code && errors.ifsc_code)}
//                               helperText={touched.ifsc_code && errors.ifsc_code}
//                             />
//                             <TextField
//                               label={t("depositedBanks.branchName")}
//                               name={`depositedBanks[${index}].branch_name`}
//                               value={dep.branch_name}
//                               InputProps={{ readOnly: true }}
//                               fullWidth
//                               error={Boolean(touched.branch_name && errors.branch_name)}
//                               helperText={touched.branch_name && errors.branch_name}
//                             />
//                           </TwoFieldRow>

//                           {/* Scheme as read-only TextField */}
//                           <TextField
//                             label={t("depositedBanks.typeOfScheme")}
//                             name={`depositedBanks[${index}].type_of_scheme`}
//                             value={dep.type_of_scheme || ""}
//                             InputProps={{ readOnly: true }}
//                             fullWidth
//                             error={Boolean(touched.type_of_scheme && errors.type_of_scheme)}
//                             helperText={touched.type_of_scheme && errors.type_of_scheme}
//                             sx={{ mb: 2 }}
//                           />

//                           <TwoFieldRow>
//                             <TextField
//                               label={t("depositedBanks.depositedAmount")}
//                               name={`depositedBanks[${index}].deposted_amt`}
//                               value={dep.deposted_amt}
//                               onChange={formik.handleChange}
//                               onBlur={formik.handleBlur}
//                               fullWidth
//                               error={Boolean(touched.deposted_amt && errors.deposted_amt)}
//                               helperText={touched.deposted_amt && errors.deposted_amt}
//                             />
//                             <TextField
//                               label={t("depositedBanks.dateOfDeposit")}
//                               name={`depositedBanks[${index}].date_of_deposit`}
//                               type="date"
//                               InputLabelProps={{ shrink: true }}
//                               value={dep.date_of_deposit || ""}
//                               onChange={formik.handleChange}
//                               onBlur={formik.handleBlur}
//                               fullWidth
//                               error={Boolean(touched.date_of_deposit && errors.date_of_deposit)}
//                               helperText={touched.date_of_deposit && errors.date_of_deposit}
//                               inputProps={{
//                                 max: today // Prevent selecting future dates in the date picker
//                               }}
//                             />
//                           </TwoFieldRow>

//                           <TwoFieldRow>
//                             <TextField
//                               select
//                               label={t("depositedBanks.modeOfDeposit")}
//                               name={`depositedBanks[${index}].mode_of_payment`}
//                               value={dep.mode_of_payment || ""}
//                               onChange={formik.handleChange}
//                               onBlur={formik.handleBlur}
//                               fullWidth
//                               error={Boolean(touched.mode_of_payment && errors.mode_of_payment)}
//                               helperText={touched.mode_of_payment && errors.mode_of_payment}
//                             >
//                               <MenuItem value="">{t("depositedBanks.selectMode")}</MenuItem>
//                               <MenuItem value="NEFT">NEFT</MenuItem>
//                               <MenuItem value="Cash">Cash</MenuItem>
//                               <MenuItem value="Cheque">Cheque</MenuItem>
//                               <MenuItem value="RTGS">RTGS</MenuItem>
//                               <MenuItem value="UPI">UPI</MenuItem>
//                             </TextField>

//                             <TextField
//                               label={t("depositedBanks.remark")}
//                               name={`depositedBanks[${index}].remark`}
//                               value={dep.remark || ""}
//                               onChange={formik.handleChange}
//                               onBlur={formik.handleBlur}
//                               fullWidth
//                               multiline
//                               error={Boolean(touched.remark && errors.remark)}
//                               helperText={touched.remark && errors.remark}
//                             />
//                           </TwoFieldRow>

//                           <Box sx={{ display: "flex", flexDirection: "column", mb: 1 }}>
//                             <UploadWithLabel
//                               label={t("depositedBanks.uploadStatement")}
//                               name={`depositedBanks[${index}].statement_doc`}
//                               onChange={(e) => {
//                                 const file = e.currentTarget.files[0];
//                                 if (file) {
//                                   formik.setFieldValue(
//                                     `depositedBanks[${index}].statement_doc`,
//                                     file
//                                   );
//                                   formik.setFieldTouched(`depositedBanks[${index}].statement_doc`, true);
//                                 }
//                               }}
//                               accept=".pdf,application/pdf"
//                               file={dep.statement_doc}
//                             />
//                             {touched.statement_doc && errors.statement_doc && !formik.values.statement_doc && (
//                               <Typography color="error" variant="caption" sx={{ mt: 0.5 }}>
//                                 {errors.statement_doc}
//                               </Typography>
//                             )}
//                           </Box>

//                           <Button
//                             variant="outlined"
//                             color="error"
//                             disabled={formik.values.depositedBanks.length === 1}
//                             onClick={() => arrayHelpers.remove(index)}
//                             sx={{ mt: 1 }}
//                           >
//                             {t("common.remove")}
//                           </Button>
//                         </Box>
//                       );
//                     })}
//                     <Button
//                       variant="contained"
//                       sx={{ mt: 2 }}
//                       onClick={() =>
//                         arrayHelpers.push({
//                           acc_no: "",
//                           bank_name: "",
//                           ifsc_code: "",
//                           branch_name: "",
//                           date_of_deposit: "",
//                           deposted_amt: "",
//                           particulars: "",
//                           remark: "",
//                           client_id: "",
//                           mode_of_payment: "",
//                           type_of_scheme: "",
//                           statement_doc: null,
//                         })
//                       }
//                     >
//                       {t("depositedBanks.addDepositedBank")}
//                     </Button>
//                   </>
//                 )}
//               </FieldArray>

//               <Box
//                 sx={{
//                   mt: 4,
//                   p: 2,
//                   border: "1px solid #999",
//                   borderRadius: 2,
//                   backgroundColor: "#f9f9f9",
//                 }}
//               >
//                 <Typography variant="h6" gutterBottom>
//                   {t("depositedBanks.totalDepositedAmountReadOnly")}
//                 </Typography>
//                 <TextField
//                   label={t("depositedBanks.totalDepositedAmount")}
//                   value={formik.values.depositedBanks
//                     .reduce((sum, d) => sum + (Number(d.deposted_amt) || 0), 0)
//                     .toFixed(2)}
//                   InputProps={{ readOnly: true }}
//                   fullWidth
//                   error={Boolean(formik.errors._totalMismatch)}
//                   helperText={formik.errors._totalMismatch}
//                 />
//               </Box>

//               <Box mt={1} sx={{ display: "flex", justifyContent: "space-between" }}>
//                 <Button
//                   variant="outlined"
//                   onClick={() => activeTab > 0 && setActiveTab(activeTab - 1)}
//                 >
//                   {t("common.back")}
//                 </Button>
//                 <Button type="submit" variant="contained">
//                   {t("common.next")}
//                 </Button>
//               </Box>
//             </Paper>
//           </Container>
//         </Form>
//       )}
//     </Formik>
//   );
// };

// export default DepositedBanksSection;



import React from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Container,
  Paper,
  Stack,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";
import TwoFieldRow from "./twoFieldsRow";
import UploadWithLabel from "./uploadWithLable";
import { Formik, Form, FieldArray } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";

const DepositedBanksSection = ({
  depositedBanks,
  setDepositedBanks,
  activeTab,
  setActiveTab,
  totalInvestment,
  schemeOptions,
  investments,
}) => {
  const { t, i18n } = useTranslation();
  // console.log("Investments in DepositedBanksSection:", investments);

  // Function to check if a date is in the future
  const isFutureDate = (dateString) => {
    if (!dateString) return false;
    const inputDate = new Date(dateString);
    const today = new Date();
    // Reset times to compare only dates
    today.setHours(0, 0, 0, 0);
    inputDate.setHours(0, 0, 0, 0);
    return inputDate > today;
  };

  // Create validation schema with conditional validation for acc_no
  const createValidationSchema = (t) =>
    Yup.object({
      depositedBanks: Yup.array()
        .of(
          Yup.object({
            acc_no: Yup.string()
              .test(
                "acc-no-required",
                t("depositedBanks.validation.accNoRequired"),
                function (value) {
                  // Get the current bank data to check if it's CASH
                  const { bank_name } = this.parent;
                  // If bank_name is "CASH", then acc_no is not required
                  if (bank_name === "CASH") {
                    return true; // Validation passes for CASH
                  }
                  // Otherwise, acc_no is required
                  return !!value && value.trim() !== "";
                }
              ),
            bank_name: Yup.string().required(t("depositedBanks.validation.bankNameRequired")),
            branch_name: Yup.string().required(t("depositedBanks.validation.branchNameRequired")),
            ifsc_code: Yup.string().required(t("depositedBanks.validation.ifscCodeRequired")),
            deposted_amt: Yup.number()
              .typeError(t("depositedBanks.validation.depositedAmtNumber"))
              .required(t("depositedBanks.validation.depositedAmtRequired")),
            date_of_deposit: Yup.date()
              .required(t("depositedBanks.validation.dateRequired"))
              .nullable()
              .test(
                "not-future-date",
                t("depositedBanks.validation.dateNotFuture"),
                (value) => {
                  if (!value) return true; // Let required validation handle empty dates
                  return !isFutureDate(value);
                }
              ),
            mode_of_payment: Yup.string().required(t("depositedBanks.validation.modeRequired")),
            type_of_scheme: Yup.string().required(t("depositedBanks.validation.schemeRequired")),
            remark: Yup.string().nullable(),
            statement_doc: Yup.mixed()
              .required(t("depositedBanks.validation.statementRequired"))
              .test(
                "fileType",
                t("depositedBanks.validation.fileMustBePDF"),
                (value) => !value || (value && value.type === "application/pdf")
              )
              .test(
                "fileSize",
                t("baseInfo.validation.fileSizeExceeded"),
                (value) => !value || value.size <= 2 * 1024 * 1024
              ),
          })
        )
        .min(1, t("depositedBanks.validation.atLeastOne")),
    });

  const validationSchema = React.useMemo(() => createValidationSchema(t), [i18n.language]);

  // Updated: Autofill bank details on acc_no change
  const handleAccountChange = (formikHelpers, index, acc_no) => {
    // Check if this is a CASH option (starts with "CASH_")
    if (acc_no && acc_no.startsWith("CASH_")) {
      // Extract scheme from CASH option (format: "CASH_FD")
      const scheme = acc_no.replace("CASH_", "");
      // Set empty account number for CASH transactions
      formikHelpers.setFieldValue(`depositedBanks[${index}].acc_no`, "");
      formikHelpers.setFieldValue(`depositedBanks[${index}].bank_name`, "CASH");
      formikHelpers.setFieldValue(`depositedBanks[${index}].ifsc_code`, "CASH");
      formikHelpers.setFieldValue(`depositedBanks[${index}].branch_name`, "CASH");
      formikHelpers.setFieldValue(`depositedBanks[${index}].type_of_scheme`, scheme);
      return;
    }

    // Regular investment account
    const selectedInvestment = investments.find((inv) => inv.inv_account_no === acc_no);
    
    if (selectedInvestment) {
      formikHelpers.setFieldValue(`depositedBanks[${index}].acc_no`, selectedInvestment.inv_account_no || "");
      formikHelpers.setFieldValue(`depositedBanks[${index}].bank_name`, selectedInvestment.inv_bank_name || "");
      formikHelpers.setFieldValue(`depositedBanks[${index}].ifsc_code`, selectedInvestment.inv_ifsc_code || "");
      formikHelpers.setFieldValue(`depositedBanks[${index}].branch_name`, selectedInvestment.inv_branch_name || "");
      formikHelpers.setFieldValue(`depositedBanks[${index}].type_of_scheme`, selectedInvestment.inv_scheme || "");
    } else {
      // Clear fields if no matching investment found
      formikHelpers.setFieldValue(`depositedBanks[${index}].bank_name`, "");
      formikHelpers.setFieldValue(`depositedBanks[${index}].ifsc_code`, "");
      formikHelpers.setFieldValue(`depositedBanks[${index}].branch_name`, "");
      formikHelpers.setFieldValue(`depositedBanks[${index}].type_of_scheme`, "");
      formikHelpers.setFieldValue(`depositedBanks[${index}].acc_no`, acc_no || "");
    }
  };

  // Prepare investment options for the dropdown
  const getInvestmentOptions = () => {
    const options = [];
    const schemeWithAccount = new Set(); // Track schemes that have account numbers
    
    // First, add all investment accounts with their schemes
    investments.forEach((inv) => {
      if (inv.inv_account_no && inv.inv_scheme) {
        const scheme = inv.inv_scheme;
        const displayLabel = `${inv.inv_account_no} - ${scheme}`;
        options.push({
          value: inv.inv_account_no,
          label: displayLabel,
          scheme: scheme,
          hasAccount: true
        });
        // Mark this scheme as having an account
        schemeWithAccount.add(scheme);
      }
    });
    
    // Add CASH options only for schemes that don't already have an account
    schemeOptions.forEach((scheme) => {
      if (scheme && !schemeWithAccount.has(scheme)) {
        options.push({
          value: `CASH_${scheme}`,
          label: `- ${scheme}`,
          scheme: scheme,
          hasAccount: false
        });
      }
    });
    
    return options;
  };

  const investmentOptions = getInvestmentOptions();

  // Build a map of scheme -> total allowed investment amount from the investments prop
  const getSchemeInvestmentTotals = () => {
    const schemeTotals = {};
    investments.forEach((inv) => {
      if (inv.inv_scheme) {
        const scheme = inv.inv_scheme;
        schemeTotals[scheme] = (schemeTotals[scheme] || 0) + (Number(inv.inv_amt) || 0);
      }
    });
    return schemeTotals;
  };

  return (
    <Formik
      initialValues={{ depositedBanks }}
      validationSchema={validationSchema}
      enableReinitialize
      validate={(values) => {
        const errors = {};

        // --- Existing: overall total must match totalInvestment ---
        const sumDeposited = values.depositedBanks.reduce(
          (sum, d) => sum + (Number(d.deposted_amt) || 0),
          0
        );
        if (
          totalInvestment !== undefined &&
          Number(sumDeposited.toFixed(2)) !== Number(totalInvestment.toFixed(2))
        ) {
          errors._totalMismatch = t("depositedBanks.totalMismatchMessage", {
            sumDeposited: sumDeposited.toFixed(2),
            totalInvestment: Number(totalInvestment).toFixed(2),
          });
        }

        // --- New: per-scheme deposited total must match that scheme's investment total ---
        const schemeInvestmentTotals = getSchemeInvestmentTotals();

        // Sum up what has been deposited per scheme from the form values
        const schemeDepositedTotals = {};
        values.depositedBanks.forEach((dep) => {
          const scheme = dep.type_of_scheme;
          if (scheme) {
            schemeDepositedTotals[scheme] =
              (schemeDepositedTotals[scheme] || 0) + (Number(dep.deposted_amt) || 0);
          }
        });

        // Check each scheme that has a known investment total
        const schemeMismatches = [];
        Object.entries(schemeInvestmentTotals).forEach(([scheme, allowedTotal]) => {
          const deposited = schemeDepositedTotals[scheme] || 0;
          if (Number(deposited.toFixed(2)) !== Number(allowedTotal.toFixed(2))) {
            schemeMismatches.push(
              t("depositedBanks.schemeTotalMismatchMessage", {
                scheme,
                deposited: deposited.toFixed(2),
                expected: allowedTotal.toFixed(2),
              })
            );
          }
        });

        if (schemeMismatches.length > 0) {
          errors._schemeMismatch = schemeMismatches.join(" | ");
        }

        return errors;
      }}
      onSubmit={(values) => {
        setDepositedBanks(values.depositedBanks);
        setActiveTab(activeTab + 1);
      }}
    >
      {(formik) => (
        <Form noValidate>
          <Container maxWidth={false} sx={{ mt: 5, maxWidth: 800 }}>
            <Paper elevation={4} sx={{ p: 4, borderRadius: 3 }}>
              <Typography variant="h4" fontWeight="700" color="primary.main" gutterBottom>
                {t("depositedBanks.heading")}
              </Typography>
              <FieldArray name="depositedBanks">
                {(arrayHelpers) => (
                  <>
                    {formik.values.depositedBanks.map((dep, index) => {
                      const touched = formik.touched.depositedBanks?.[index] || {};
                      const errors = formik.errors.depositedBanks?.[index] || {};
                      
                      // Check if current selection is CASH
                      const isCash = dep.bank_name === "CASH" || 
                                     dep.ifsc_code === "CASH" || 
                                     dep.branch_name === "CASH";
                      
                      // Get today's date in YYYY-MM-DD format for max date
                      const today = new Date().toISOString().split('T')[0];
                      
                      return (
                        <Box
                          key={index}
                          mb={2}
                          p={2}
                          sx={{ border: "1px solid #ccc", borderRadius: 2 }}
                        >
                          <TwoFieldRow>
                            <FormControl fullWidth sx={{ minWidth: 250 }}>
                              <InputLabel id={`acc_no_label_${index}`}>
                                {t("depositedBanks.accNo")}
                              </InputLabel>
                              <Select
                                labelId={`acc_no_label_${index}`}
                                name={`depositedBanks[${index}].acc_no`}
                                value={dep.acc_no || ""}
                                label={t("depositedBanks.accNo")}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  formik.handleChange(e);
                                  handleAccountChange(formik, index, value);
                                }}
                                onBlur={formik.handleBlur}
                                error={Boolean(touched.acc_no && errors.acc_no)}
                              >
                                <MenuItem value="">
                                  <em>{t("common.select")}</em>
                                </MenuItem>
                                {investmentOptions.map((option) => (
                                  <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                  </MenuItem>
                                ))}
                              </Select>
                              {touched.acc_no && errors.acc_no && (
                                <Typography color="error" variant="caption" sx={{ ml: 2 }}>
                                  {errors.acc_no}
                                </Typography>
                              )}
                            </FormControl>

                            <TextField
                              label={t("depositedBanks.bankName")}
                              name={`depositedBanks[${index}].bank_name`}
                              value={dep.bank_name}
                              InputProps={{ readOnly: true }}
                              fullWidth
                              sx={{ ml: 2, minWidth: 250 }}
                            />
                          </TwoFieldRow>

                          <TwoFieldRow>
                            <TextField
                              label={t("depositedBanks.ifscCode")}
                              name={`depositedBanks[${index}].ifsc_code`}
                              value={dep.ifsc_code}
                              InputProps={{ readOnly: true }}
                              fullWidth
                              error={Boolean(touched.ifsc_code && errors.ifsc_code)}
                              helperText={touched.ifsc_code && errors.ifsc_code}
                            />
                            <TextField
                              label={t("depositedBanks.branchName")}
                              name={`depositedBanks[${index}].branch_name`}
                              value={dep.branch_name}
                              InputProps={{ readOnly: true }}
                              fullWidth
                              error={Boolean(touched.branch_name && errors.branch_name)}
                              helperText={touched.branch_name && errors.branch_name}
                            />
                          </TwoFieldRow>

                          {/* Scheme as read-only TextField */}
                          <TextField
                            label={t("depositedBanks.typeOfScheme")}
                            name={`depositedBanks[${index}].type_of_scheme`}
                            value={dep.type_of_scheme || ""}
                            InputProps={{ readOnly: true }}
                            fullWidth
                            error={Boolean(touched.type_of_scheme && errors.type_of_scheme)}
                            helperText={touched.type_of_scheme && errors.type_of_scheme}
                            sx={{ mb: 2 }}
                          />

                          <TwoFieldRow>
                            <TextField
                              label={t("depositedBanks.depositedAmount")}
                              name={`depositedBanks[${index}].deposted_amt`}
                              value={dep.deposted_amt}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              fullWidth
                              error={Boolean(touched.deposted_amt && errors.deposted_amt)}
                              helperText={touched.deposted_amt && errors.deposted_amt}
                            />
                            <TextField
                              label={t("depositedBanks.dateOfDeposit")}
                              name={`depositedBanks[${index}].date_of_deposit`}
                              type="date"
                              InputLabelProps={{ shrink: true }}
                              value={dep.date_of_deposit || ""}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              fullWidth
                              error={Boolean(touched.date_of_deposit && errors.date_of_deposit)}
                              helperText={touched.date_of_deposit && errors.date_of_deposit}
                              inputProps={{
                                max: today // Prevent selecting future dates in the date picker
                              }}
                            />
                          </TwoFieldRow>

                          <TwoFieldRow>
                            <TextField
                              select
                              label={t("depositedBanks.modeOfDeposit")}
                              name={`depositedBanks[${index}].mode_of_payment`}
                              value={dep.mode_of_payment || ""}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              fullWidth
                              error={Boolean(touched.mode_of_payment && errors.mode_of_payment)}
                              helperText={touched.mode_of_payment && errors.mode_of_payment}
                            >
                              <MenuItem value="">{t("depositedBanks.selectMode")}</MenuItem>
                              <MenuItem value="NEFT">NEFT</MenuItem>
                              <MenuItem value="Cash">Cash</MenuItem>
                              <MenuItem value="Cheque">Cheque</MenuItem>
                              <MenuItem value="RTGS">RTGS</MenuItem>
                              <MenuItem value="UPI">UPI</MenuItem>
                            </TextField>

                            <TextField
                              label={t("depositedBanks.remark")}
                              name={`depositedBanks[${index}].remark`}
                              value={dep.remark || ""}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              fullWidth
                              multiline
                              error={Boolean(touched.remark && errors.remark)}
                              helperText={touched.remark && errors.remark}
                            />
                          </TwoFieldRow>

                          <Box sx={{ display: "flex", flexDirection: "column", mb: 1 }}>
                            <UploadWithLabel
                              label={t("depositedBanks.uploadStatement")}
                              name={`depositedBanks[${index}].statement_doc`}
                              onChange={(e) => {
                                const file = e.currentTarget.files[0];
                                if (file) {
                                  formik.setFieldValue(
                                    `depositedBanks[${index}].statement_doc`,
                                    file
                                  );
                                  formik.setFieldTouched(`depositedBanks[${index}].statement_doc`, true);
                                }
                              }}
                              accept=".pdf,application/pdf"
                              file={dep.statement_doc}
                            />
                            {touched.statement_doc && errors.statement_doc && !formik.values.statement_doc && (
                              <Typography color="error" variant="caption" sx={{ mt: 0.5 }}>
                                {errors.statement_doc}
                              </Typography>
                            )}
                          </Box>

                          <Button
                            variant="outlined"
                            color="error"
                            disabled={formik.values.depositedBanks.length === 1}
                            onClick={() => arrayHelpers.remove(index)}
                            sx={{ mt: 1 }}
                          >
                            {t("common.remove")}
                          </Button>
                        </Box>
                      );
                    })}
                    <Button
                      variant="contained"
                      sx={{ mt: 2 }}
                      onClick={() =>
                        arrayHelpers.push({
                          acc_no: "",
                          bank_name: "",
                          ifsc_code: "",
                          branch_name: "",
                          date_of_deposit: "",
                          deposted_amt: "",
                          particulars: "",
                          remark: "",
                          client_id: "",
                          mode_of_payment: "",
                          type_of_scheme: "",
                          statement_doc: null,
                        })
                      }
                    >
                      {t("depositedBanks.addDepositedBank")}
                    </Button>
                  </>
                )}
              </FieldArray>

              <Box
                sx={{
                  mt: 4,
                  p: 2,
                  border: "1px solid #999",
                  borderRadius: 2,
                  backgroundColor: "#f9f9f9",
                }}
              >
                <Typography variant="h6" gutterBottom>
                  {t("depositedBanks.totalDepositedAmountReadOnly")}
                </Typography>
                <TextField
                  label={t("depositedBanks.totalDepositedAmount")}
                  value={formik.values.depositedBanks
                    .reduce((sum, d) => sum + (Number(d.deposted_amt) || 0), 0)
                    .toFixed(2)}
                  InputProps={{ readOnly: true }}
                  fullWidth
                  error={Boolean(formik.errors._totalMismatch || formik.errors._schemeMismatch)}
                  helperText={
                    formik.errors._totalMismatch ||
                    (formik.errors._schemeMismatch && (
                      <span>
                        {formik.errors._schemeMismatch.split(" | ").map((msg, i) => (
                          <span key={i} style={{ display: "block" }}>
                            {msg}
                          </span>
                        ))}
                      </span>
                    ))
                  }
                />
              </Box>

              <Box mt={1} sx={{ display: "flex", justifyContent: "space-between" }}>
                <Button
                  variant="outlined"
                  onClick={() => activeTab > 0 && setActiveTab(activeTab - 1)}
                >
                  {t("common.back")}
                </Button>
                <Button type="submit" variant="contained">
                  {t("common.next")}
                </Button>
              </Box>
            </Paper>
          </Container>
        </Form>
      )}
    </Formik>
  );
};

export default DepositedBanksSection;